import {CommonBadlXlsxDataProcessor} from '../export-care-plan-common-badl-xlsx-data';

export class ClothingXlsxDataProcessor extends CommonBadlXlsxDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
